import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTrx = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#trx_svg__a)'>
      <path fill='#E53935' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        d='M16.449 7.435 5.625 5.443l5.696 14.334 7.938-9.67zm-.174.877 1.656 1.575-4.529.82zm-3.856 2.23L7.646 6.584l7.801 1.435zm-.34.7-.779 6.436L7.104 7.115zm.72.342 5.015-.908-5.752 7.008z'
      />
    </g>
    <defs>
      <clipPath id='trx_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgTrx)
export default ForwardRef
